import { useContext } from 'react';

import { JonumVerificationStatus } from '#src/__generated__/globalTypes.ts';
import { ConfigContext } from '#src/contexts/config/index.ts';
import { CurrentUserContext } from '#src/contexts/currentUser/index.ts';

const AFFECTED_COUNTRY = ['FR'];

export const useApplyJonumRestriction = () => {
  const currentUser = useContext(CurrentUserContext)?.currentUser;
  const countryCode = useContext(ConfigContext)?.currentLocation.countryCode;

  const isInAffectedCountry =
    !!countryCode && AFFECTED_COUNTRY.includes(countryCode.toUpperCase());
  const jonumVerification = currentUser?.jonumVerification;

  if (!jonumVerification) {
    return isInAffectedCountry;
  }

  return jonumVerification.status !== JonumVerificationStatus.EXEMPT;
};
